import { serialize } from "../../../helpers/helpers";
import { apiRequest } from "../../../apiHelper/apiRequest";

const s_list = async params => {
  return apiRequest(
    "/subscribers/list?" + serialize(params),
    {
      method: "GET"
    },
    'ptp_client'
  );
}

const s_add = async params => {
  let add_response = await apiRequest(
    "/subscribers/add",
    {
      'method': "POST",
      'headers': {
        'content-type': 'application/json'
      },
      'body': JSON.stringify(params)
    },
    'ptp_client'
  );

  if (typeof (add_response.id) !== 'undefined' && add_response.id)
    return add_response.id;
  else
    return 0;
}

const s_update = async params => {
  let add_response = await apiRequest(
    "/subscribers/update",
    {
      'method': "PUT",
      'headers': {
        'content-type': 'application/json'
      },
      'body': JSON.stringify(params)
    },
    'ptp_client'
  );

  if (typeof (add_response.id) !== 'undefined' && add_response.id)
    return add_response.id;
  else
    return 0;
}

const s_remove = async (id = 0) => {
  let remove_response = await apiRequest(
    "/subscribers/delete/" + id,
    {
      method: "DELETE"
    },
    'ptp_client'
  );

  if (typeof (remove_response.id) !== 'undefined' && remove_response.id)
    return remove_response.id;
  else
    return 0;
}

const subscribersService = {
  s_list,
  s_add,
  s_update,
  s_remove,
};
export default subscribersService;